export interface IAttestationAPI {
  Id: number;
  Nome: string | null;
  UserName: string | null;
  Matricula: string | null;
  UserMail: string | null;
  DataEntrega: string | null;
  DataAtestado?: string | null;
  Tipo: string;
  DeDiaHora: string | null;
  AteDiaHora: string | null;
  Status: number | string;
  OBS?: string;
  Motivo?: string;
  MotivoDescricao?: string | null;
  SubMotivoDescricao?: string | null;
}

export interface IAttestationResponse {
  Data: IAttestationAPI[];
  Success: boolean;
  Description: string;
  ErrorCode: number;
}

export type DateFilterOption = 'Hoje' | 'Última semana' | 'Últimos 30 dias';
export type StatusFilterOption = 'Aprovados' | 'Reprovados' | 'Em Análise';
export type TodayFilterOption = 'Sim' | 'Não';

export const DATE_OPTIONS: DateFilterOption[] = ['Hoje', 'Última semana', 'Últimos 30 dias'];
export const STATUS_OPTIONS: StatusFilterOption[] = ['Aprovados', 'Reprovados', 'Em Análise'];
export const TODAY_OPTIONS: TodayFilterOption[] = ['Sim', 'Não'];

export const STATUS_VALUES_MAP: Record<StatusFilterOption, number[]> = {
  'Aprovados': [5, 7],
  'Reprovados': [6],
  'Em Análise': [3],
};
